export enum ConditionType {
    AND = 1,
    OR = 2
}